document.querySelectorAll('.video-container').forEach(container => {
  const video = container.querySelector('video');
  const overlay = container.querySelector('.video-overlay');

  overlay.addEventListener('click', () => {
    overlay.style.display = 'none'; // Hide overlay
    video.play(); // Play video
  });
});

document.addEventListener("DOMContentLoaded", function () {
  // Set an interval to check if the reviews are loaded
  const interval = setInterval(() => {
    // Select the reviews container using your class
    const reviewsContainer = document.querySelector('.large-10.medium-10.small-12.cell .media-object-section.main_review_stars div');

    if (reviewsContainer && reviewsContainer.innerHTML.trim() !== "") {
      // Stop the interval when reviews are loaded
      clearInterval(interval);

      // Process the reviews
      console.log("Reviews loaded. Processing...");

      // Extract review data using regex
      const reviewText = reviewsContainer.innerHTML;
      const regex = /(\d+(\.\d+)?)/; // Adjust regex based on your review data structure
      const matches = reviewText.match(regex);

      if (matches) {
        const extractedData = matches[0]; // Extracted number (rating or count)
        console.log("Extracted Reviews Data:", extractedData);

        // Append the extracted data to the .cr__totalreview-heading class
        const headingElement = document.querySelector('.cr__totalreview-heading');
        if (headingElement) {
          headingElement.textContent += ` ${extractedData} Reviews •` ; // Appending the extracted data
        } else {
          console.log(".cr__totalreview-heading element not found.");
        }
      } else {
        console.log("No matching reviews data found.");
      }
    }
  }, 300); // Check every 300ms (0.3 seconds)
});



document.addEventListener("DOMContentLoaded", function () {
  // Set an interval to wait for reviews to load
  const interval = setInterval(() => {
    // Select all review cards
    const reviewCards = document.querySelectorAll('.areviews_slide_image_details'); // Replace with actual class for the review cards

    if (reviewCards.length > 0) {
      // Loop through each review card
      reviewCards.forEach(card => {
        const nameElement = card.querySelector('.areviews_user_name'); // Replace with actual class for the name
        const imageElement = card.querySelector('.user_image'); // Replace with actual class for the user image
        const dateElement = card.querySelector('.comment_container'); // Replace with actual class for the date

        if (nameElement && imageElement && dateElement) {
          // Create a wrapper div
          const wrapperDiv = document.createElement('div');
          wrapperDiv.classList.add('user-info-wrapper'); // Add a class to the wrapper div for styling

          // Append the image and name to the wrapper div
          wrapperDiv.appendChild(imageElement);
          wrapperDiv.appendChild(nameElement);

          // Move the wrapper div below the date element
          dateElement.after(wrapperDiv);
        }
      });

      // Stop the interval after processing all cards
      clearInterval(interval);
    }
  }, 300); // Check every 300ms
});


// reviews section starts from here

document.addEventListener("DOMContentLoaded", function () {
  // Set an interval to check for the reviews
const interval = setInterval(() => {
  // Select the reviews container using the given selector
  const reviewsContainer = document.querySelector(
    '.large-10.medium-10.small-12.cell .media-object-section.main_review_stars span.third_main_starts_box'
  );

  // Check if the reviewsContainer exists and has non-empty content
  if (reviewsContainer && reviewsContainer.innerHTML.trim() !== "") {
    // Stop the interval when reviews are loaded
    clearInterval(interval);

    // Fetch the reviews content
    const reviewsContent = reviewsContainer.innerHTML;

    // Update the .cr__reviews element with the reviews content
    const crReviewsElement = document.querySelector('.cr__reviews');
    if (crReviewsElement) {
      crReviewsElement.innerHTML = reviewsContent; // Append stars content
    } else {
      console.error(".cr__reviews element not found.");
    }
  }
}, 300); // Check every 300ms (0.3 seconds)

});

// reviews section ends here



document.addEventListener("DOMContentLoaded", function () {
  const selectElement = document.querySelector('.single-option-selector'); // Select the dropdown
  const radioContainer = document.getElementById('dynamic-radio-buttons'); // Container for radio buttons

  // Function to update radio buttons dynamically
  function updateRadioButtons() {
    // Clear existing radio buttons
    radioContainer.innerHTML = '';

    // Loop through <select> options to create radio buttons
    Array.from(selectElement.options).forEach((option) => {
      const label = document.createElement('label');
      label.innerHTML = `
        <img 
          src="https://cdn.shopify.com/s/files/1/0788/9282/6903/files/Vector.svg?v=1733387450" 
          style="display: ${option.selected ? 'inline-block' : 'none'}; width: 19px; height: 14px;"
          class="dynamic-radio-image"
        >
        <input 
          type="radio" 
          name="dynamic-options" 
          value="${option.value}" 
          ${option.selected ? 'checked' : ''}>
        ${option.text}
      `;
      label.style.display = "block"; // Display each label as block for better layout

      // If the radio button is selected, add a red border to the label
      if (option.selected) {
        label.style.border = '1px solid #FFBB4E';
      }

      radioContainer.appendChild(label);
    });
  }

  // Initial load: Populate radio buttons
  updateRadioButtons();

  // Sync radio buttons when <select> changes
  selectElement.addEventListener('change', function () {
    updateRadioButtons();
  });

  // Sync <select> when a radio button is clicked
  radioContainer.addEventListener('change', function (event) {
    if (event.target.type === 'radio') {
      // Remove border and hide image for all labels
      Array.from(radioContainer.querySelectorAll('label')).forEach(label => {
        label.style.border = 'none';
        const image = label.querySelector('.dynamic-radio-image');
        if (image) {
          image.style.display = 'none'; // Hide the image
        }
      });

      // Add border and show image for the selected label
      const selectedLabel = event.target.closest('label');
      if (selectedLabel) {
        selectedLabel.style.border = '1px solid #FFBB4E';
        const image = selectedLabel.querySelector('.dynamic-radio-image');
        if (image) {
          image.style.display = 'inline-block'; // Show the image
        }
      }

      // Sync selected radio value with the dropdown
      selectElement.value = event.target.value;
      selectElement.dispatchEvent(new Event('change')); // Trigger Shopify updates if needed
    }
  });
});


const div1 = document.getElementById("shopify-section-template--23609038504215__1ef32df8-aa4d-4d60-9e96-8951d4c5f337");
const div2 = document.getElementById("shopify-section-template--23609038504215__ddc1325b-9bb4-4980-8899-fda3a8204e52");
const divnew = document.getElementById("shopify-section-template--23609038504215__store_features_MtABVd");
const divnew1 = document.getElementById("shopify-section-template--23609038504215__custom_content_4kY8dY");

if (div1 && div2 && divnew && divnew1) {
  const newParentDiv = document.createElement("div");
  newParentDiv.className = "how-it-work-section";

  const parentElement = div1.parentElement;
  parentElement.insertBefore(newParentDiv, div1);

  newParentDiv.appendChild(div2);
  newParentDiv.appendChild(divnew1);
  newParentDiv.appendChild(div1);
  newParentDiv.appendChild(divnew);

}
const div3 = document.getElementById("shopify-section-template--23609038504215__custom_content_z3TArr");
const div4 = document.getElementById("shopify-section-template--23609038504215__newsletter_zA3cLq");

if (div3 && div4) {
  const newParentDiv2 = document.createElement("div");
  newParentDiv2.className = "discount-section";
  newParentDiv2.id = "discount-section";

  const parentElement2 = div3.parentElement;
  parentElement2.insertBefore(newParentDiv2, div3);

  newParentDiv2.appendChild(div3);
  newParentDiv2.appendChild(div4);
}

const div5 = document.getElementById("shopify-section-template--23609038504215__richtext_yjPBTe");
const div6 = document.getElementById("shopify-section-template--23609038504215__019cd7f7-100f-404c-8dc8-3d99289aadeb");
const div7 = document.getElementById("shopify-section-template--23609038504215__custom_content_iNyPwh");


if (div5 && div6 && div7) {
  const newParentDiv3 = document.createElement("div");
  newParentDiv3.className = "wash-process";

  const parentElement3 = div5.parentElement;
  parentElement3.insertBefore(newParentDiv3, div5);

  newParentDiv3.appendChild(div5);
  newParentDiv3.appendChild(div6);
  newParentDiv3.appendChild(div7);
}
const div8 = document.getElementById("shopify-section-template--23609038504215__info_lines_idVK4T");
const div9 = document.getElementById("shopify-section-template--23609038504215__custom_content_8EjtMz");

if (div8 && div9) {
  const newParentDiv4 = document.createElement("div");
  newParentDiv4.className = "result-section";

  const parentElement4 = div8.parentElement;
  parentElement4.insertBefore(newParentDiv4, div8);

  newParentDiv4.appendChild(div8);
  newParentDiv4.appendChild(div9);
}
const div10 = document.getElementById("shopify-section-template--23609038504215__custom_content_Tr4bBr");
const div11 = document.getElementById("shopify-section-template--23609038504215__1734421345bbffbb54");

if (div10 && div11) {
  const newParentDiv5 = document.createElement("div");
  newParentDiv5.className = "testimonial-section";

  const parentElement5 = div10.parentElement;
  parentElement5.insertBefore(newParentDiv5, div10);

  newParentDiv5.appendChild(div10);
  newParentDiv5.appendChild(div11);
}

const div12 = document.querySelector(".cr__container");
const div13 = document.getElementById("shopify-section-template--23609039061271__1629746450643786911");

if (div12 && div13) {
  const newParentDiv6 = document.createElement("div");
  newParentDiv6.className = "reviews";

  const parentElement6 = div12.parentElement;
  parentElement6.insertBefore(newParentDiv6, div12);

  newParentDiv6.appendChild(div12);
  newParentDiv6.appendChild(div13);
}



// js to append the arrow icon on cta button of 'How it work' section

const bannerLink = document.querySelector('#shopify-section-template--23609038504215__ddc1325b-9bb4-4980-8899-fda3a8204e52 .wrap-block .btn');
if (bannerLink) {
    const image = document.createElement('img');
    image.src = 'https://cdn.shopify.com/s/files/1/0788/9282/6903/files/mynaui_arrow-long-left.svg';
    bannerLink.appendChild(image);
}

const fastestclean = document.querySelector('.custom__item--text_dqcnTL .custom-text .btn');
if (fastestclean) {
    const image = document.createElement('img');
    image.src = 'https://cdn.shopify.com/s/files/1/0788/9282/6903/files/mynaui_arrow-long-left.svg';
    fastestclean.appendChild(image);
}

document.querySelectorAll('.row-template--19863069557015__b50e257a-2b02-4172-9ab8-5dae103d380d-1689327646284ad433-0 .feature-row__text').forEach(row => {
    const wrapper = document.createElement('div');
    wrapper.classList.add('about-btn-wrapper');

    const btnLink = row.querySelector('.btn');
    if (btnLink) {
        wrapper.appendChild(btnLink);
    }

    const shopNowLink = document.createElement('a');
    shopNowLink.href = '/collections/shop-all';
    shopNowLink.className = 'shop-now-btn';

    const shopNowButton = document.createElement('button');
    shopNowButton.className = 'shop-now';
    shopNowButton.textContent = 'SHOP NOW';

    const shopNowImg = document.createElement('img');
    shopNowImg.src = 'https://cdn.shopify.com/s/files/1/0788/9282/6903/files/mynaui_arrow-long-left.svg?v=1733131215';
    shopNowImg.alt = 'arrow';
    shopNowImg.className = 'arrow-icon';

    shopNowButton.appendChild(shopNowImg);
    shopNowLink.appendChild(shopNowButton);
    wrapper.appendChild(shopNowLink);

    row.appendChild(wrapper);
});

document.querySelectorAll('.custom__item--text_xNHyy7, .row-image_with_text_QhCWHK .row-text').forEach(row => {
    const wrapper = document.createElement('div');
    wrapper.classList.add('about-btn-wrapper');

    const btnLink = row.querySelector('.btn');
    if (btnLink) {
        wrapper.appendChild(btnLink);
    }

    const shopNowLink = document.createElement('a');
    shopNowLink.href = '/collections/shop-all';
    shopNowLink.className = 'shop-now-btn';

    const shopNowButton = document.createElement('button');
    shopNowButton.className = 'shop-now';
    shopNowButton.textContent = 'SHOP NOW';

    const shopNowImg = document.createElement('img');
    shopNowImg.src = 'https://cdn.shopify.com/s/files/1/0788/9282/6903/files/mynaui_arrow-long-left.svg?v=1733131215';
    shopNowImg.alt = 'arrow';
    shopNowImg.className = 'arrow-icon';

    shopNowButton.appendChild(shopNowImg);
    shopNowLink.appendChild(shopNowButton);
    wrapper.appendChild(shopNowLink);

    row.appendChild(wrapper);
});


document.addEventListener("DOMContentLoaded", function() {
  // Select the elements
  const imageElement = document.querySelector(".custom__item--image_px8YQp");
  const videoElement = document.querySelector(".custom__item--video_zhzjHB");

  // Click event listener
  imageElement.addEventListener("click", function() {
    // Hide the image element
    imageElement.style.display = "none";

    // Show the video element
    videoElement.style.display = "block";
  });
});

document.addEventListener("DOMContentLoaded", function() {
  // Select the elements
  const homeimageElement = document.querySelector(".custom__item--image_Gfh33C img");
  const homevideoElement = document.querySelector("#shopify-section-template--23609038504215__1ef32df8-aa4d-4d60-9e96-8951d4c5f337");
  const shopifySectionElement = document.querySelector("#shopify-section-template--23609038504215__custom_content_4kY8dY");

  // Click event listener
  homeimageElement.addEventListener("click", function() {
    // Hide the image element
    homeimageElement.style.display = "none";
    shopifySectionElement.style.display = "none";

    // Show the video element
    homevideoElement.style.display = "block";
  });
});






// home review js starts from here

document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('#shopify-section-template--23609038504215__1734421345bbffbb54 .jdgm-rev').forEach(function(review) {
        // Extract the inner HTML of `.jdgm-rev__body`
        var bodyContent = review.querySelector('#shopify-section-template--23609038504215__1734421345bbffbb54 .jdgm-rev__body').innerHTML;

        // Find `.jdgm-rev__header` inside the current `.jdgm-rev`
        var header = review.querySelector('#shopify-section-template--23609038504215__1734421345bbffbb54 .jdgm-rev__header');

        if (header) {
            // Create a new div element
            var newDiv = document.createElement('div');

            // Add class `appended-content` to the new div
            newDiv.classList.add('appended-content');

            // Set the content of the new div
            newDiv.innerHTML = bodyContent;

            // Append the new div to the header
            header.appendChild(newDiv);
        }

        // Find `.jdgm-rev__author` inside the current `.jdgm-rev`
        var authorDiv = review.querySelector('#shopify-section-template--23609038504215__1734421345bbffbb54 .jdgm-rev__author');

        if (authorDiv) {
            // Prepend the image to the `.jdgm-rev__author` div
            var imgTag = `<img src="https://cdn.shopify.com/s/files/1/0788/9282/6903/files/emojione-v1_flag-for-canada.svg?v=1734531254" alt="Canada Flag" class="appended-image" style="width: 20px; height: 20px; margin-right: 5px;">`;
            authorDiv.innerHTML = imgTag + authorDiv.innerHTML;
        }
    });
});


// home review js ends here



// redirecting to the terms and conditions page programmatically (12-19-2024)

document.addEventListener('DOMContentLoaded', function() {
    document.querySelector('.terms').addEventListener('click', function () {
        // Base URL ko define karo
        const baseURL = window.location.origin; // Current domain ka base URL
        
        // Redirect to the desired page
        const targetURL = `${baseURL}/policies/terms-of-service`;
        window.location.href = targetURL;
    });
});

document.addEventListener('DOMContentLoaded', function () {
  const accordions = document.querySelectorAll('.accordion-toggle');
  
  accordions.forEach(toggle => {
    toggle.addEventListener('click', function () {
      this.classList.toggle('active');
      const content = this.nextElementSibling;
      if (content.style.maxHeight) {
        content.style.maxHeight = null;
      } else {
        content.style.maxHeight = content.scrollHeight + "px";
      }
    });
  });
});


document.addEventListener("DOMContentLoaded", function () {
    // Select the element with the ID "trigger-popup"
    const triggerButton = document.getElementById("trigger-popup");

    if (triggerButton) {
        // Add a click event listener to the button
        triggerButton.addEventListener("click", function () {
            // Select the popup element with the class "ecomsend__Popover__Widget__CustomContainer"
              const popupElement = document.querySelector(".ecomsend__Popover__Widget__CustomContainer");

            if (popupElement) {
                // Trigger the click event on the popup element
                popupElement.click();
                console.log("Popup triggered!");
            } else {
                console.error("Popup element not found!");
            }
        });
    } else {
        console.error("Trigger button not found!");
    }
});

document.addEventListener("DOMContentLoaded", function () {
    if (window.innerWidth <= 500) {
        const wrapper = document.querySelector(".row-image_with_text_QhCWHK .imgWrapper");

        if (wrapper) {
            const newImage = document.createElement("img");
            newImage.src = "https://cdn.shopify.com/s/files/1/0788/9282/6903/files/1_Gal_Old_Glory_Sprayer_copy_1_2_-min.png";
            newImage.alt = "Mobile Image";
            newImage.classList.add("banner-mobile-image"); // Optional: Add a class for styling
            
            wrapper.appendChild(newImage);
        }
    }
});
// document.addEventListener("DOMContentLoaded", function () {
//   const imageElement = document.querySelector("#shopify-section-template--23609038504215__custom_content_4kY8dY .custom__image");

//   if (window.innerWidth <= 500) {
//     imageElement.src = "https://cdn.shopify.com/s/files/1/0788/9282/6903/files/Frame_119.png?v=1736248213";
//   }
// });
document.addEventListener("DOMContentLoaded", function () {
  const imageElement1 = document.querySelector("#shopify-section-template--23609038569751__custom_content_xGDdnw .custom__image");

  if (window.innerWidth <= 500) {
    imageElement1.src = "https://cdn.shopify.com/s/files/1/0788/9282/6903/files/Frame_119.png?v=1736248213"; // Replace with your new image URL
  }
});


document.addEventListener("DOMContentLoaded", function () {
    // Check if the URL contains the form's anchor or identifier
    if (window.location.hash === "#contact_form") {
        // Delay the scroll to ensure the page has fully loaded
        setTimeout(function () {
            const targetSection = document.getElementById('discount-section');
            if (targetSection) {
                targetSection.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                });
            }
        }, 500); // Adjust delay if necessary
    }
});

const successDiv = document.querySelector('.newsletter-form .form--success');
if (successDiv) {
  successDiv.innerHTML = '<ul><li>Thank you for subscribing! Use code <strong>ES-194B4431B529</strong> for 5% off</li></ul>';
}
const errorDiv = document.querySelector('.newsletter-form .errors');
if (errorDiv) {
  errorDiv.innerHTML = '<ul><li>Please enter valid email address!</li></ul>';
};

document.addEventListener("DOMContentLoaded", function () {
    fetch('/?section_id=banner-check-icons')
        .then(response => response.text())
        .then(data => {
            document.querySelector('.row-image_with_text_QhCWHK .featured-row__subtext').insertAdjacentHTML('beforeend', data); 
        })
        .catch(error => console.error('Error loading section:', error));
});
// document.addEventListener("DOMContentLoaded", function () {
//     let section = document.querySelector("#shopify-section-template--23609038504215__feature_row_cXV7RQ, #shopify-section-template--23967158567191__feature_row_cXV7RQ");
    
//     if (section) {
//         section.style.backgroundImage = "url('https://cdn.shopify.com/s/files/1/0788/9282/6903/files/IMG_9204_1-min.png')";
//         section.style.backgroundSize = "cover";
//         section.style.backgroundPosition = "center";
//         section.style.backgroundRepeat = "no-repeat";
//     }
// });
document.addEventListener("DOMContentLoaded", function () {
    let section = document.querySelector("#shopify-section-template--23609038504215__feature_row_cXV7RQ, #shopify-section-template--23967158567191__feature_row_cXV7RQ");

    function updateBackground() {
        if (section) {
            if (window.matchMedia("(max-width: 500px)").matches) {
                section.style.backgroundImage = "url('https://cdn.shopify.com/s/files/1/0788/9282/6903/files/banner-mobile-min.png')";
            } else {
                section.style.backgroundImage = "url('https://cdn.shopify.com/s/files/1/0788/9282/6903/files/IMG_9204_1-min.png')";
            }
        }
    }

    updateBackground(); // Run on page load

    window.addEventListener("resize", updateBackground); // Run on window resize
});

document.addEventListener("DOMContentLoaded", function () {
    const btn = document.querySelector(".row-image_with_text_QhCWHK .btn");

    if (btn) {
        btn.id = "customButton"; // Assign an ID
        btn.href = "#how-video";
        // btn.href = "#how-it-work-video";
    }
});

document.addEventListener("DOMContentLoaded", function () {
    const customDiv = document.querySelector("#shopify-section-template--23609038504215__custom_content_4kY8dY .content-indent");

    if (customDiv) {
        customDiv.id = "how-it-work-video"; // Assign a new ID
    }
});


// Mutation Observer ka istemal karke dynamically load hone wale elements ko detect karenge
// const observer = new MutationObserver((mutations) => {
//     mutations.forEach((mutation) => {
//         mutation.addedNodes.forEach((node) => {
//             if (node.nodeType === 1) { 
//                 let targetDiv = document.querySelector(".ecomsend__Modal__TitleText");

//                 if (targetDiv && !document.querySelector(".custom-heading")) {
//                     let newHeading = document.createElement("h1");
//                     newHeading.textContent = "Mera Naya Heading"; 
//                     newHeading.classList.add("custom-heading");
//                     targetDiv.insertAdjacentElement("afterend", newHeading);
//                 }
//             }
//         });
//     });
// });


// observer.observe(document.body, { childList: true, subtree: true });


// document.addEventListener("DOMContentLoaded", function () {
//     let pTags = document.querySelectorAll(".appended-content p"); // Sabhi <p> tags ko select karo

//     pTags.forEach(function (pTag) {
//         let text = pTag.innerText;  
//         let words = text.split(" "); 

//         if (words.length > 10) {
//             let truncatedText = words.slice(0, 10).join(" ") + " ...";  
//             pTag.innerText = truncatedText;  
//         }
//     });
// });

// document.addEventListener("DOMContentLoaded", function () {
//     let pTags = document.querySelectorAll(".appended-content p"); // Sabhi <p> tags ko select karein
//     let charLimit = 105; // Kitne characters dikhane hain (change karein as needed)

//     pTags.forEach(function (pTag) {
//         let text = pTag.innerText.trim(); // Text lein aur extra spaces hatayein

//         if (text.length > charLimit) {
//             let truncatedText = text.substring(0, charLimit) + " ...";  
//             pTag.innerText = truncatedText;  
//         }
//     });
// });

// updated code starts from here 

const checkModalPresence = () => {
    const modalElement = document.querySelector('.react-responsive-modal-modal');
    if (modalElement) {
        appendDivAfterHeader();
    }
    setTimeout(checkModalPresence, 200);
};
const appendDivAfterHeader = () => {
    try {
        const modalElement = document.querySelector('.react-responsive-modal-modal');
        if (!modalElement) return;
        const header = modalElement.querySelector('header');
        if (header && !modalElement.querySelector('.discount-popup-heading')) {
            const newDiv = document.createElement('div');
            newDiv.classList.add('discount-popup-heading');
            newDiv.innerHTML = '<p>Save 5%</p>';
            header.insertAdjacentElement('afterend', newDiv);
        }
    } catch (error) {
        console.error("Error in appendDivAfterHeader:", error);
    }
};
checkModalPresence();

// updated code ends here 
















